import React, { useState, useEffect } from "react";
import Stack from "@mui/material/Stack";
import { Typography, Box } from "@mui/material";
import { makeStyles } from "@mui/styles";
import placeHolder from "../../../assets/images/placeHolder.png";
import unavailable from "../../../assets/images/price_unavailable.png";
import quantity from "../../../assets/images/min_not_met.png";
import { functions } from "../../../utils";

const useStyles = makeStyles(() => ({
  customStack: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  iconStack: {
    position: "absolute",
    top: "8px",
    right: "8px",
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
}));

export default function ProductGalleryViewer(props) {
  const [selectedImage, setSelectedImage] = useState(placeHolder);
  const [images, setImages] = useState([]);
  let styleName = props.styleName ?? "";
  const classes = useStyles();
  const errorImage =
    props.errorType === "product"
      ? unavailable
      : props.errorType === "generalError"
      ? placeHolder
      : quantity;

  useEffect(() => {
    setImages(props.images);
    props.baring
      ? setSelectedImage(props.images[1])
      : setSelectedImage(props.images[0]);
  }, [props.images, props.baring]);
  return (
    <Stack
      justifyContent="center"
      alignItems="center"
      border={"1px solid #e0e0e0"}
      position="relative"
    >
      {props.icons && (
        <Box className={classes.iconStack}>
          {props.icons.map((icon, key) => {
            const iconElement = functions.getIcons(icon);
            return iconElement ? (
              <Typography key={key} className="icons">
                {iconElement}
              </Typography>
            ) : null;
          })}
        </Box>
      )}

      <img
        src={props.error ? errorImage : selectedImage}
        onError={(e) => {
          if (props.isCoreStyle) {
            var newImage = props.images.find((img) => img == e.target.src);
            if (newImage == null) {
              var text = props.images[0];
              var index = text.indexOf("-");

              if (index != -1 && index + 1 < text.length) {
                var letterAfterDash =
                  "-" + text.substring(index + 1, index + 2);
                console.log(letterAfterDash);
              }
              e.target.src = e.target.src.replace("-O", letterAfterDash);
              newImage = props.images.find((img) => img == e.target.src);
              newImage = newImage ? newImage.replace(/-[A-Za-z]/g, "-O") : null;
            }

            if (props.imageErrorCount >= 3) {
              e.target.src = placeHolder;
              props.setImageErrorCount(0);
              return;
            }
            if (props.imageErrorCount == 2 || newImage == null) {
              styleName = styleName.replace("/", "-");
              var imageUrlParts = newImage
                ? newImage.split("/")
                : props.images[0].split("/");
              var lastPartUrl = imageUrlParts[imageUrlParts.length - 1];
              const [first, ...rest] = lastPartUrl.split("_");
              const remainder = rest.join("_");
              var newImageUrl =
                "https://api2.hooverandstrong.com/catalog_images/" +
                styleName +
                "_" +
                remainder;
              e.target.src = newImageUrl || errorImage;
              props.setImageErrorCount(props.imageErrorCount + 1);
              return;
            }
            if (
              newImage &&
              (newImage.includes("-B") ||
                newImage.includes("-T") ||
                newImage.includes("-V") ||
                newImage.includes("-F") ||
                newImage.includes("-Q"))
            ) {
              if (props.imageErrorCount == 0) {
                newImage = newImage.replace(/-[A-Za-z]/g, "-O");
              } else {
                newImage = newImage.replace(/-[A-Za-z]/g, "-C");
              }
              e.target.src = newImage || errorImage;
            } else if (newImage && newImage.includes("-O")) {
              newImage = newImage ? newImage.replace("-O", "-C") : null;
              e.target.src = newImage || errorImage;
              props.setImageErrorCount(props.imageErrorCount + 1);
            } else if (newImage && newImage.includes("-C")) {
              newImage = newImage ? newImage.replace("-C", "-O") : null;
              e.target.src = newImage || errorImage;
              props.setImageErrorCount(props.imageErrorCount + 1);
            } else {
              e.target.src = placeHolder;
            }
          } else {
            e.target.src = placeHolder;
          }
        }}
        alt="Selected Product"
        className="selected-product"
      />
      <Stack className={classes.customStack}>
        {!props.error &&
          images?.length > 1 &&
          images.map((image, index) => (
            <img
              key={index}
              src={image}
              style={{
                padding:
                  props.isCoreStyle && index > 0 ? "8px 0px 8px 0px" : "0px",
              }}
              className="detail-imgs"
              alt="Mini Product"
              onError={(e) => {
                if (props.isCoreStyle) {
                  var numImages = props.images.length;
                  var newImage = props.images.find(
                    (img) => img == e.target.src
                  );

                  if (
                    newImage &&
                    (newImage.includes("-B") ||
                      newImage.includes("-T") ||
                      newImage.includes("-V") ||
                      newImage.includes("-F") ||
                      newImage.includes("-Q"))
                  ) {
                    newImage = newImage.replace(/-[A-Za-z]/g, "-C");
                    e.target.src = newImage || errorImage;
                  }

                  if (newImage == props.images[0] && !props.miniFlipTried) {
                    if (newImage && newImage.includes("-O")) {
                      newImage = newImage ? newImage.replace("-O", "-C") : null;
                      e.target.src = newImage || errorImage;
                    } else if (newImage && newImage.includes("-C")) {
                      newImage = newImage ? newImage.replace("-C", "-O") : null;
                      e.target.src = newImage || errorImage;
                    } else {
                      e.target.src = placeHolder;
                    }
                    props.setMiniFlipTried(true);
                  } else if (
                    numImages > 1 &&
                    newImage == props.images[1] &&
                    !props.miniFlipTried2
                  ) {
                    if (newImage && newImage.includes("-O")) {
                      newImage = newImage ? newImage.replace("-O", "-C") : null;
                      e.target.src = newImage || errorImage;
                    } else if (newImage && newImage.includes("-C")) {
                      newImage = newImage ? newImage.replace("-C", "-O") : null;
                      e.target.src = newImage || errorImage;
                    } else {
                      e.target.src = placeHolder;
                    }
                    props.setMiniFlipTried2(true);
                  } else {
                    e.target.src = placeHolder;
                  }
                } else {
                  e.target.src = placeHolder;
                }
              }}
              onClick={() => {
                props.setMiniFlipTried(false);
                props.setMiniFlipTried2(false);
                setSelectedImage(image);
              }}
            />
          ))}
      </Stack>
    </Stack>
  );
}
